export const Announcements = {
	attributes: { fill: 'none', viewBox: '0 0 24 24' },
	children: [
		{
			type: 'path',
			attributes: {
				fill: 'currentColor',
				d: 'M21.3804 11.8431H17.5604C17.2204 11.8431 16.9404 11.5631 16.9404 11.2231C16.9404 10.8831 17.2204 10.6031 17.5604 10.6031H21.3804C21.7204 10.6031 22.0004 10.8831 22.0004 11.2231C22.0004 11.5631 21.7204 11.8431 21.3804 11.8431Z',
			},
		},
		{
			type: 'path',
			attributes: {
				fill: 'currentColor',
				d: 'M17.3801 8.45318C17.1201 8.45318 16.8801 8.28317 16.7901 8.02318C16.6801 7.70318 16.8601 7.35318 17.1901 7.24318L20.9201 6.03317C21.2501 5.92317 21.5901 6.10317 21.7001 6.43317C21.8101 6.75317 21.6301 7.10318 21.3001 7.21318L17.5701 8.42318C17.5101 8.44318 17.4401 8.45318 17.3801 8.45318Z',
			},
		},
		{
			type: 'path',
			attributes: {
				fill: 'currentColor',
				d: 'M20.9599 16.4431C20.8999 16.4431 20.8299 16.4431 20.7699 16.4131L17.0399 15.2031C16.7199 15.0931 16.5399 14.7531 16.6399 14.4231C16.7499 14.1031 17.0899 13.9231 17.4199 14.0231L21.1499 15.2331C21.4699 15.3431 21.6499 15.6831 21.5499 16.0131C21.4699 16.2731 21.2199 16.4431 20.9599 16.4431Z',
			},
		},
		{
			type: 'path',
			attributes: {
				fill: 'currentColor',
				d: 'M14.29 5.15317C12.75 6.24317 9.92 7.77317 6.07 7.77317H2.84C2.38 7.77317 2 8.15317 2 8.61317V13.8332C2 14.2932 2.38 14.6732 2.84 14.6732H4.93V17.6832C4.93 18.2532 5.39 18.7132 5.96 18.7132C6.53 18.7132 6.99 18.2532 6.99 17.6832V14.7132C10.37 14.9332 12.89 16.2832 14.3 17.2832C14.85 17.6732 15.61 17.2732 15.61 16.5932V5.84317C15.61 5.16317 14.85 4.76317 14.3 5.15317H14.29Z',
			},
		},
	],
};
